<div class="flex flex-col">
  <form [formGroup]="inputForm">
    <div class="flex flex-row justify-start items-center">
      <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName"
               particleAnalytics
               analyticsCategory="data-survey"
               analyticsAction="create-custom-form">
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-center">
      <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastName"
               particleAnalytics
               analyticsCategory="data-survey"
               analyticsAction="create-custom-form">
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-center">
      <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title"
               particleAnalytics
               analyticsCategory="data-survey"
               analyticsAction="create-custom-form">
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-center">
      <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email"
               particleAnalytics
               analyticsCategory="data-survey"
               analyticsAction="create-custom-form">
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-center">
      <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
        <mat-label>Phone</mat-label>
        <input matInput formControlName="phone"
               particleAnalytics
               analyticsCategory="data-survey"
               analyticsAction="create-custom-form">
      </mat-form-field>
    </div>
    <div *ngIf="subAccountPackages && subAccountPackages.length>0" class="flex flex-row justify-start items-center">
      <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
        <mat-label>Packages</mat-label>
        <mat-select placeholder="Packages" formControlName="packages" multiple>
          <mat-option *ngFor="let subAccountPackage of subAccountPackages" [value]="subAccountPackage.code">
            {{subAccountPackage.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-center">
      <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
        <mat-label>Message</mat-label>
        <textarea matInput type="text" formControlName="message"
                  rows="5">
              </textarea>
      </mat-form-field>
    </div>
  </form>
</div>


